// @flow
import { ReactComponent as Icon } from 'esm-web-pro/assets/images/sidePanel/timeline.svg';
import styled, { css } from 'styled-components';
import sidePanelIconCss from 'esm-web-pro/components/layout/sidePanel/icons/sidePanelIconCss';

const TimelineIcon = styled(Icon)`
    ${sidePanelIconCss}
    // ${(props) => css`background-color: ${props.theme.global.colors.brand}`}
`;

export default TimelineIcon;
